import { render, staticRenderFns } from "./VehicleOfInterest.vue?vue&type=template&id=f88b0142"
import script from "./VehicleOfInterest.vue?vue&type=script&lang=js"
export * from "./VehicleOfInterest.vue?vue&type=script&lang=js"
import style0 from "./VehicleOfInterest.vue?vue&type=style&index=0&id=f88b0142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports